export default [
  'actions-modal',
  'actions-queue',
  'admin-actions',
  'alerts',
  'alarms-notification',
  'alarms-notifications',
  'applications',
  'attributes',
  'auto-services',
  'average-transaction-time',
  'banners',
  'call-center',
  'connected-devices',
  'consumer-traffic-by-customer',
  'contracts',
  'create-alarm-step',
  'credits',
  'customer-contracts',
  'customers',
  'dashboard',
  'date-picker',
  'device-actions-modal',
  'device-actions',
  'file-uploader',
  'general',
  'graph-theme',
  'groupings',
  'guide',
  'home',
  'inventory-detailed',
  'inventory',
  'invoices-actions',
  'invoices',
  'lorawan',
  'main-dashboard',
  'main',
  'maps',
  'monthly-billing',
  'operational',
  'permissions',
  'reports',
  'requests',
  'requests-tracking',
  'researches',
  'roaming',
  'roles',
  'satisfaction-survey',
  'service-requests',
  'sessions',
  'simcards-online-operator',
  'simcards-online-product',
  'simcards-online-state',
  'simcards-online-technology',
  'simcards-online-tecnology',
  'simcards-online.estado',
  'sms-send',
  'status',
  'super-list',
  'table',
  'transaction-by-type',
  'transaction-history',
  'transaction-status',
  'transactions-by-status',
  'transactions-dashboard',
  'transactions',
  'transations-by-status',
  'transfers',
  'users',
  'wizard',
];
